import { useGetContext } from '../api/lending/lapiHooks';
import { useSuspenseGetContext } from '../api/lending/lapiHooks.suspense';

export function useStateKey() {
  const { context, getContext, loadingContext } = useGetContext();

  return {
    stateKey: context.stateKey || null,
    fetchSiteContext: getContext,
    loadingStateKey: loadingContext,
  };
}

export function useSuspenseStateKey() {
  const { context, getContext } = useSuspenseGetContext();

  return {
    stateKey: context.stateKey || null,
    fetchSiteContext: getContext,
  };
}
